import Layout from '../components/layouts/index'
import InventoryPage from '../components/modules/views/dashboard/Inventario/Index'

const Inventario = () => {
  return (
    <Layout className='px-4 md:px-8'>
      <InventoryPage />
    </Layout>
  )
}

export default Inventario
